<template>
   <div>
      <div class=" container-fluid" id="managecustomer">
        <div class="llp-container-section  heightcontainer ">
      <div>
      <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
      </div>
      <!-- Start the code for this screen here -->
      <div id="addcustomer" class="container-fluid overflow-auto pb-4 menu-margin-top" style="padding-left:0px;padding-right:0px">
         <div class="llp-container-section mr-sm-3 mr-lg-0" style="z-index:1">
            <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Customer Demographics</b></span></nav>
            <center>
        <span :style="msgcolor">
          <b>{{message}}</b>
        </span>
      </center>
            <br>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <input type="radio" class="mr-1"   value="P" id="P" v-model.trim="customer.customerType" @click="Reset()"/>Personal</div>
             <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <input type="radio" class="mr-1"  value="B" id="B" v-model.trim="customer.customerType" @click="Reset()" />Business</div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="prefixddlabel" class="col-form-label col-form-label-sm">Prefix</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 align-items-center ">
                  <select id="prefixdd" v-model.trim="customer.selectedUserPrefixCode"  class="form-control input-sm " >
                     <option value="">Select a Prefix...</option>
                     <option v-for="(option, index) of userprefixs" :value="option.userPrefixC" :key="index">
                        {{ option.userPrefixX }}
                     </option>
                  </select>

               </div> <!--col end-->
            </div><!--row end-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"  v-if="customer.customerType === 'P'">
                  <label id="fnamelabel" class="col-form-label col-form-label-sm required">First Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"   v-if="customer.customerType === 'P'">
                  <input id="fname"
                     placeholder="Enter First Name"
                     v-model.trim="customer.firstName"  class="form-control input-sm"
                     size="11"
                     v-validate="'required'"
                     data-vv-name="First Name"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('First Name')" class="alert-danger">{{ errors.first('First Name') }}</div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"   v-if="customer.customerType === 'B'">
                  <label id="fnamelabel" class="col-form-label col-form-label-sm">First Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"  v-if="customer.customerType === 'B'">
                  <input id="fname"
                     placeholder="Enter First Name"
                     v-model.trim="customer.firstName"
                     size="11"
                     class="form-control input-sm"
                     data-vv-name="First Name"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('First Name')" class="alert-danger" > {{ errors.first('First Name') }} </div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="mnamelabel" class="col-form-label col-form-label-sm" >Middle Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="mname"
                     placeholder="Enter Middle Name"
                     name="source"
                     v-model.trim="customer.middleName"
                     class="form-control input-sm"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="lnamelabel" class="col-form-label col-form-label-sm">Last Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input  id="lname"
                     placeholder="Enter Last Name"
                     v-model.trim="customer.lastName"
                     class="form-control input-sm"
                     data-vv-name="Last Name"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('Last Name')" class="alert-danger" > {{ errors.first('Last Name') }} </div>
               </div><!--col end-->
            </div><!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2" v-if="customer.customerType === 'B'">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="fnamelabel" class="col-form-label col-form-label-sm required">Business Name</label>
               </div><!--col end-->
               <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="Bname"
                     placeholder="Enter Business Name"
                     v-model.trim="customer.businessName"
                     class="form-control input-sm"
                     v-validate="'required'"
                     size="20"
                     data-vv-name="Business Name"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('Business Name')" class="alert-danger" > {{ errors.first('Business Name') }} </div>
               </div><!--col end-->
            </div><!--row end-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2" >
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="adr1label" class="col-form-label col-form-label-sm">Address Line1</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="adr1"
                     placeholder="Enter Address1"
                     v-model.trim="customer.addressLine1"
                     class="form-control input-sm"
                     maxlength="50"/>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="adr2label" class="col-form-label col-form-label-sm">Address Line2</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="adr2"
                     placeholder="Enter Address2"
                     v-model.trim="customer.addressLine2"
                     class="form-control input-sm"
                     maxlength="50"/>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="citylabel" class="col-form-label col-form-label-sm">City</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="city"
                     placeholder="Enter City"
                     v-model.trim="customer.city"
                     class="form-control input-sm"
                     maxlength="50"
                     onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
               </div><!--col end-->
            </div><!--row end-->
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="statesddlabel" class="col-form-label col-form-label-sm">State</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                 <!-- <select id="statesdd"
                     class="form-control input-sm"
                     v-model="customer.selectedStateCode"
                     >
                     <option value="">Select a State...</option>
                     <option v-for="(option,index) in states" :value="option.stateFipsC" :key="index">
                        {{ option.stateN }}
                     </option>
                  </select> -->
                  <multiselect
    style="width:100%; color: #777;"
    v-model="customer.selectedStateCode"
    :options="states"
    placeholder="Select a State..."
    :value="states.stateFipsC"
     label="stateN"
    selected="selected"
    id="statesdd">
  </multiselect>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="zipcodelabel" class="col-form-label col-form-label-sm">Zip Code</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input  id="zipcode"
                     placeholder="Enter 5 Digit zip"
                     title="Please enter 5 digits"
                     v-model="customer.zipCode"
                       @input="zipDecoder"
                     class="form-control input-sm"
                     maxlength="5"
                     v-validate="{ regex: /^(\d)(?!\1+$)/, digits:5 }"
                     data-vv-name="Zip Code"
                     onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"/>
                  <div v-if="errors.has('Zip Code')" class="alert-danger" > {{ errors.first('Zip Code') }} </div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="countrylabel" class="col-form-label col-form-label-sm">Country</label>
               </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="country"
                     placeholder="Enter Country"
                     class="form-control input-sm"
                     v-model="customer.countryName"
                     disabled="true"/>
               </div><!--col end-->
            </div><!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"> <label id="emaillabel" class="col-form-label col-form-label-sm">Email</label> </div>
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="email"
                     placeholder="Enter email"
                     v-model.trim="customer.emailId"
                     class="form-control input-sm"
                     v-validate="'email'"
                     data-vv-name="Email" ref="emailref"
                     maxlength="50"/>
                  <div v-if="errors.has('Email')" class="alert-danger" > {{ errors.first('Email') }} </div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="pnumlabel" class="col-form-label col-form-label-sm">Cell/Primary Phone</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                   <input
            id="pnum"
            placeholder="Enter Mobile Number"
            v-model="customer.mobileNumber"
            class="form-control input-sm"
            title="Please enter 10 digits"
            maxlength="10"
            v-validate="'min:10|max:14'"
            data-vv-name="Cell Phone"
            @input="formatCellPhoneNumber"
            @blur="formatCellPhoneNumber"
          />
          <div v-if="errors.has('Cell Phone')" class="alert-danger">{{ errors.first('Cell Phone') }}</div>
          <div v-if="this.fraudMobileError !=''" class="alert-danger">{{fraudMobileError}}</div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="pnumlabel" class="col-form-label col-form-label-sm" v-if="customer.mobileNumber!=''">Fraud Cell</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customer.mobileNumber!=''">
                  <select
            name="fraudIndicator"
            placeholder="Select fraudIndicator"
            v-model.trim="customer.fraudCell"
            data-vv-as="indicator"
            @change="changeFraudInd"
            class="form-control input-sm"
          >
            <option
              v-for="indicator in fraudIndicatorList"
              v-bind:key="indicator.key"
            >{{indicator.keyValue}}</option>
          </select>
          <div
            v-if="errors.has('Fraud Cell Phone')"
            class="alert-danger"
          >{{ errors.first('Fraud Cell Phone') }}</div>

               </div><!--col end-->

            </div><!--row end-->

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                   <label id="wnumlabel" class="col-form-label col-form-label-sm">Secondary Phone</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="wnum"
                     placeholder="Enter Work Number"
                     v-model="customer.workNumber"
                     class="form-control input-sm"
                     title="Please enter 10 digits"
                     maxlength="10"
                     v-validate="'min:10|max:14'" data-vv-name="Work Phone"
                     @input="formatWorkPhoneNumber"
                     @blur="formatWorkPhoneNumber"
                     />
                             <div v-if="errors.has('Work Phone')" class="alert-danger">{{ errors.first('Work Phone') }}</div>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                   <label id="fnumlabel" class="col-form-label col-form-label-sm">Fax #</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <input id="fnum"
                     placeholder="Enter Fax Number"
                     v-model="customer.faxNumber"
                     class="form-control input-sm"
                     title="Please enter 10 digits"
                     maxlength="10"
                     v-validate="'min:10|max:14'" data-vv-name="Fax"
                     @input="formatFaxNumber"
                     @blur="formatFaxNumber"
                     />
                  <div v-if="errors.has('Fax')" class="alert-danger">{{ errors.first('Fax') }}</div>
               </div><!--col end-->
            </div><!--row end-->

            <div v-show="false" class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                  <label id="pcontactddlabel" class="col-form-label col-form-label-sm">Preferred Contact</label>
                </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select id="pcontactdd"
                     v-model="customer.preferredContactCode"
                     class="form-control input-sm"
                     disabled="disabled">
                     <option v-for="(option,index) of preferredContactOptions" :value="option.value" :key="index">
                        {{ option.text }}
                     </option>
                  </select>
               </div><!--col end-->
            </div>

            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
               <div class="col-12 col-md-12 d-flex justify-content-lg-end">
                  <label id="statusddlabel" class="col-form-label col-form-label-sm">Status</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <select id="statusdd" v-model="customer.selectedStatusCode" class="form-control input-sm">
                     <option v-for="(option,index) in statusOptions" :value="option.value" :key="index">{{ option.text }}</option>
                  </select>
               </div><!--col end-->
               <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm"> New Eligibility Flag </label>
        </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
        <select  name="fraudIndicator"  v-model.trim="customer.fraudInd" data-vv-as="indicator" class="form-control input-sm" @change="eligibilityFlag">
          <option v-for="(indicator,index) in fraudIndicatorList" v-bind:key="indicator.key">{{indicator.keyValue}} </option>
        </select>
        </div><!--col end-->
        <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm required" v-if="customer.fraudInd == 'N' || customer.fraudCell == 'Y' || customer.fraudInd == 'R'"> Reg Flag Reason </label>
        </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3" v-if="customer.fraudInd == 'N' || customer.fraudCell == 'Y' || customer.fraudInd == 'R'">
         <select v-model.trim="customer.redFlagReason" v-validate="'required'"  name="Red Flag Reason" data-vv-name="Red Flag Reason" class="form-control input-sm">
            <option disabled value="">Select Redflag Reason</option>
            <option
              v-for="(indicator,index) in redFlagReasonList"
              v-bind:key="index"
            >{{indicator.keyValue}}</option>
          </select>
          <div v-if="errors.has('Red Flag Reason')" class="alert-danger">{{errors.first('Red Flag Reason')}} </div>
        </div><!--col end-->
            </div><!--row end-->

            <br/>
            <div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center">
                  <div class="center ">
                     <button class="btn btn-secondary" type="submit"  @click="savecustomerdata">Save</button>
                  </div>
               </div>
            </div>
            <br><br>
            <!-- End of the code for this screen here -->
         </div>
      </div>

   </div>
      </div>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcommon from '../js/http-common.js'
import httpcommonzero from '../js/http-common-zero.js'
import httpcustomer from '../js/http-customer.js'
import moment from 'moment'
import $ from 'jquery'

import { debug } from 'util'
import { bus } from '../main'
export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      message: '',
      types: [
        { id: 'P', name: 'Personal' },
        { id: 'B', name: 'Business' }
      ],
      userprefixs: [],
      fraudIndicatorList: [],
      states: [],
      preferredContactOptions: [],
      statusOptions: [],
      cuserrorslist: [],
      addcustomer: [],
      existingEmailIds: [],
      requiredfieldcontent: '*',
      redFlagReasonList: [],
      fraudMobileError: '',
      customer: this.createEmptyCustomerObject(),
      msgcolor: {
        color: 'black'
      }
    }
  },
  methods: {
    zipDecoder () {
      if (this.customer.zipCode.length == 5) {
        httpcommon.get('/statefip/zipCode/' + this.customer.zipCode)
          .then(response => {
            if (response.data.city != null) {
              this.customer.city = response.data.city
            } else {
              this.customer.city = ''
            }
            if (response.data.city != null) {
              this.getCustomerStateDetails(response.data.state)
            } else {
              this.customer.selectedStateCode = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getCustomerStateDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          this.customer.selectedStateCode = this.states[i]
        }
      }
    },
    formatCellPhoneNumber: function (event) {
      this.getCustomerMobileFraud()
      var phone = this.customer.mobileNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.mobileNumber = phone
      if (this.customer.mobileNumber == '') {
        this.customer.fraudCell = 'N'
      }
    },
    formatWorkPhoneNumber: function (event) {
      var phone = this.customer.workNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.workNumber = phone
    },
    formatFaxNumber: function (event) {
      var phone = this.customer.faxNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.faxNumber = phone
    },
    formatFraudPhoneNumber: function (event) {
      var phone = this.customer.fraudCell
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.fraudCell = phone
    },
    changeFraudInd () {
      if (this.customer.fraudInd == 'Y' && this.customer.fraudCell == 'N') {
        this.customer.redFlagReason = ''
      }
    },
    eligibilityFlag () {
      if (this.customer.fraudInd === 'R') {
        this.customer.redFlagReason = 'Review'
      } else { this.customer.redFlagReason = '' }
    },
    createEmptyCustomerObject () {
      return {
        fraudInd: 'Y',
        selectedUserPrefixCode: '',
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        selectedStateCode: '',
        countryName: 'USA',
        zipCode: '',
        emailId: '',
        confirmEmailId: '',
        workNumber: '',
        mobileNumber: '',
        faxNumber: '',
        preferredContactCode: 'A',
        customerType: 'P',
        selectedStatusCode: 'A',
        redFlagReason: '',
        fraudCell: 'N'
      }
    },
    resetObject () {
      this.customer.selectedUserPrefixCode = ''
      this.customer.firstName = ''
      this.customer.middleName = ''
      this.customer.lastName = ''
      this.customer.businessName = ''
      this.customer.addressLine1 = ''
      this.customer.addressLine2 = ''
      this.customer.city = ''
      this.customer.selectedStateCode = ''
      this.customer.countryName = 'USA'
      this.customer.zipCode = ''
      this.customer.emailId = ''
      this.customer.confirmEmailId = ''
      this.customer.workNumber = ''
      this.customer.mobileNumber = ''
      this.customer.faxNumber = ''
      this.customer.preferredContactCode = 'A'
      this.customer.selectedStatusCode = 'A'
      this.customer.redFlagReason = ''
      this.customer.fraudCell = ''
    },
    Reset () {
      this.resetObject()
      this.$validator.reset()
      this.message = ''
    },
    /* emailIdNotInTheSystem () {
       httpcommonzero.get('/digitalcontactinfo/checkduplicates/'+this.customer.emailId).then(response => {
                console.log(response.data)
                this.existingEmailIds = response.data;
                })
                .catch(e => {
                  this.cuserrorslist.push(e)
                })
      if (this.customer.emailId.length > 0) {
        for (var i = 0; i < this.existingEmailIds.length; i++) {
          var obj = this.existingEmailIds[i]
          if (obj.email == this.customer.emailId) {
            this.message = 'Email already exists. Please choose a different email id.'
            this.msgcolor.color = 'Red'
            this.$validator.flag('Email', {
            valid:false,
            invalid:true,
          })
          this.$validator.flag('ReEnter Email',{
              valid:false,
              invalid:true
            })
            return false
          }
        }
      }
      this.message = ''
      return true
    }, */
    createCustomer () {
      var date = new Date()
      var currentDate =
        date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
      let newCustomer = {
        firstName: this.customer.firstName,
        middleName: this.customer.middleName,
        lastName: this.customer.lastName,
        businessName: this.customer.businessName,
        customerType: this.customer.customerType,
        dealerId: null,
        fraudInd: this.customer.fraudInd,
        redFlagReason: this.customer.redFlagReason,
        userPrefixC:
          this.customer.selectedUserPrefixCode.length == 0
            ? null
            : this.customer.selectedUserPrefixCode,
        address: {
          street1: this.customer.addressLine1,
          street2: this.customer.addressLine2,
          city: this.customer.city,
          zipCode: this.customer.zipCode,
          stateFipsC:
            this.customer.selectedStateCode.length == 0
              ? null
              : this.customer.selectedStateCode.stateFipsC,
          country: this.customer.countryName,
          addressType: null,
          inactiveD: this.customer.selectedStatusCode == 'A' ? null : date,
          creationD: date,
          creationUserI: this.$session.get('user_id'),
          lastUpdatedD: null,
          lastUpdatedUserI: null
        },
        digitalContactInfo: {
          email: this.customer.emailId,
          faxNumber: this.customer.faxNumber.replace(/[^0-9]/g, ''),
          mobileNumber: this.customer.mobileNumber.replace(/[^0-9]/g, ''),
          preferredContact: this.customer.preferredContactCode,
          workNumber: this.customer.workNumber.replace(/[^0-9]/g, ''),
          fraudMobileNumber: this.customer.fraudCell
        },
        inactiveD: this.customer.selectedStatusCode == 'A' ? null : date,
        creationD: date,
        creationUserI: this.$session.get('user_id'),
        lastUpdatedD: null,
        lastUpdatedUserI: null
      }
      // console.log(newCustomer)
      if (this.fraudMobileError == '') {
        httpcustomer
          .post('/customer/', newCustomer)
          .then(response => {
            var status = response.data
            if (status == 'CREATED') {
              this.message = 'Customer Successfully added into the system'
              this.msgcolor.color = 'Blue'
              this.customer = this.createEmptyCustomerObject()
            } else {
              this.msgcolor.color = 'Red'
              this.message = ''
            }
          })
          .catch(e => {
            this.msgcolor.color = 'Red'
            this.message = '' || e.name || e.message
          })
      }
    },
    savecustomerdata: function () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.createCustomer()
          this.fraudMobileError = ''
          /* if (this.emailIdNotInTheSystem()) {
        this.createCustomer()
      } */
        }
      })
    },
    getCustomerMobileFraud () {
      httpcustomer
        .get(
          '/customer/checkfraudMobileNumber/' +
            this.customer.mobileNumber.replace(/[^0-9]/g, '')
        )
        .then(response => {
          if (response.data == 'Y') {
            this.fraudMobileError = 'The given MobileNumber is blocked'
          } else {
            this.fraudMobileError = ''
          }
        })
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#addcustomer').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },

  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()

    httpcommon
      .get('/userprefix/')
      .then(response => {
        this.userprefixs = response.data
      })
      .catch(e => {
        this.errors.push(e)
      }),
    httpcommon
      .get('/statefip/')
      .then(response => {
        this.states = response.data
      })
      .catch(e => {
        this.errors.push(e)
      }),
    httpcommon
      .get('/staticdata/preferredcontact/')
      .then(response => {
        this.preferredContactOptions = response.data
      })
      .catch(e => {
        this.errors.push(e)
      }),
    httpcommonzero
      .get('/digitalcontactinfo/emailids/customer')
      .then(response => {
        this.existingEmailIds = response.data
      })
      .catch(e => {
        this.errors.push(e)
      }),
    httpcommon
      .get('/staticdata/status/')
      .then(response => {
        this.statusOptions = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
    httpcommon
      .get('/keyvalues/getkeyvalues/' + 1)
      .then(response => {
        this.fraudIndicatorList = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
    httpcommon
      .get('/keyvalues/getkeyvalues/' + 23)
      .then(response => {
        this.redFlagReasonList = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
  }
}
</script>
<style scoped>
.radioButton {
  margin-left: 10%;
}
.radioLabel {
  margin-left: 1%;
}
</style>
